/** A referential catalogue: no tenant, no parameter. */
class FetchAiModelFamilies {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchAiModelFamilies;
